import { render, staticRenderFns } from "./TheSourceSlider2.vue?vue&type=template&id=7b8aad2c&scoped=true&"
import script from "./TheSourceSlider2.vue?vue&type=script&lang=js&"
export * from "./TheSourceSlider2.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceSlider2.vue?vue&type=style&index=0&id=7b8aad2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8aad2c",
  null
  
)

export default component.exports